<template>
  <div
    :key="item.image"
    :class="$style.card"
    class="card d-flex flex-column justify-content-between"
  >
    <PageCardContent
      class="p-0"
      :class="$style.cardContent"
      :image="item.image"
      :content="item.content"
      :content-class="$style.cardBody"
    />
    <div
      class="text-right"
      :class="$style.cardBody"
    >
      <CsrCardButton
        :href="item.action.href"
      >
        {{ item.action.label }}
      </CsrCardButton>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import PageCardContent, { PageCardContentProps } from '@/scripts/pages/onepager/components/PageCardContent.ts.vue';
import CsrCardButton from '../components/CsrCardButton.ts.vue';
import { LocaleItemAction } from '../types/LocaleItem';

export interface CardItem extends PageCardContentProps {
  action: LocaleItemAction & {
    href: string;
  };
}

export default Vue.extend({
  components: {
    CsrCardButton,
    PageCardContent,
  },
  props: {
    item: {
      type: Object as PropType<CardItem>,
      required: true,
    },
  },
});
</script>

<style lang="scss" module>
@import '~@/scripts/pages/onepager/styles/variables-entry';

.cardBody {
  padding: 1rem;
}

.card {
  $tolerance: calc(#{$grid-gutter-width} + 2rem);
  $max-width: 320px;
  min-width: $max-width;
  min-width: Min(#{$max-width}, calc(100vw - #{$tolerance}));
  max-width: $max-width;
  max-width: Min(#{$max-width}, calc(100vw - #{$tolerance}));
}

.cardContent {
  gap: 0rem;
}
</style>
